import { AbstractPmsApiService } from "./abstract.service";
import { AddonInterval } from "../models";
import moment from 'moment';

/**
 * @class AddonIntervalPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<AddonInterval>}
 */
export class AddonIntervalPmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/addon/:addonId/addon-interval(/:id)';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {AddonInterval}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new AddonInterval(attributes);
    }
    
    /**
     * @param {Object=} params
     * @param {Addon=} addon
     * @returns {Promise.<PaginationCollection<AddonInterval>>}
     */
    get(params = {}, addon = null) {
        
        const url = this.url({
            propertyId: addon ? addon.property_id : 0,
            addonId: addon ? addon.id : 0
        });
        
        const ignoreLB = params.hasOwnProperty('searchValue');
        
        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
                ignoreLoadingBar: ignoreLB
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }
    
    /**
     * @param {AddonInterval} addonInterval
     * @param {Addon} addon
     * @returns {Promise.<AddonInterval>}
     */
    create(addonInterval, addon) {
        
        const url = this.url({
            propertyId: addon.property_id,
            addonId: addon.id
        });
        
        return this.http
            .post(url, this.prepareModel(addonInterval.toObject()), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
    
    /**
     * @param {AddonInterval} addonInterval
     * @param {Addon} addon
     * @returns {Promise.<AddonInterval>}
     */
    update(addonInterval, addon) {
        
        const url = this.url({
            propertyId: addon.property_id,
            addonId: addon.id,
            id: addonInterval.id
        });
        
        return this.http
            .put(url, this.prepareModel(addonInterval.toObject()), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
    
    /**
     * @param {AddonInterval} addonInterval
     * @returns {Promise.<boolean>}
     */
    delete(addonInterval) {
        
        const url = this.url({
            propertyId: addonInterval.addon.property_id,
            addonId: addonInterval.addon.id,
            id: addonInterval.id
        });
        
        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Array} ids
     * @param {Addon} addon
     * @returns {Promise.<boolean>}
     */
    bulkDelete(ids, addon) {
        
        const url = this.url({
            propertyId: addon.property_id,
            addonId: addon.id
        });
        
        return this.http
                   .post(url + '/bulk-delete', {'ids': ids}, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Object}
     * @returns {Object}
     */
    prepareModel(model) {
        
        model.start_date = moment(model.start_date).format('YYYY-MM-DD') + ' 00:00:00';
        model.end_date = moment(model.end_date).format('YYYY-MM-DD') + ' 00:00:00';
        
        //transform to sync pivot data
        let roomTypes = {};
        
        for (let type of model.property_accommodation_types) {
            
            roomTypes[type.id] = type.pivot;
        }
        
        model.property_accommodation_types = roomTypes;
        
        return model;
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/addon-interval.service.js